module.exports = __webpack_public_path__ + "static/media/question-lobby.0f35c87f.png";